import connect from "react-redux/es/connect/connect";
import {setList, updateList} from "../../../../state/modules/resources";
import {
    addCart,
    addClientOrder,
    addCustomProduct,
    addDiscount,
    addGiftcard,
    addManualDiscount,
    addProductVariation,
    addRelease,
    changeCartItemQuantity,
    checkoutCart,
    checkoutMollieCart,
    deleteCart,
    fetchCart,
    fetchCarts,
    removeCartItem,
    removeDiscount,
    updateCart, updateCartItem,
    updateProductVariation,
    updateRelease,
} from "../../../../state/modules/carts";
import {API_HOST, API_ROOT, http} from "../../../../util/http";
import {handleTokenErrors} from "../../../../state/modules/errors";

import React from "react";
import {price} from "../../../../util/formatting";
import ui from "../../../../util/ui";
import {resolveBarcode} from "../../../../util/barcode";

import Button from "../../../atoms/button";
import Popup from "../../popup";
import ModuleView from "../../module-view/index";
import CustomerSelectListItem from "../../customer/customer-select-list-item";
import CustomerCreate from "../../customer/customer-create";
import ItemSelectPopup from "../../item-select-popup";
import Window from "../../window";
import Grid from "../../grid";
import CustomerCard from "../../customer/customer-card";
import ButtonGroup from "../../button-group";
import List from "../../list";
import NumberWidget from "../../number-widget";
import CartItem from "../cart-item";
import BarcodeScanner from "../../barcode-scanner";
import BarcodeListener from "../../barcode-listener";
import CustomProductTypeListItem from "../../custom-product-type/custom-product-type-list-item";
import CustomProductCreate from "../../custom-product/custom-product-create";
import ActionInput from "../../action-input";
import DataValue from "../../data-value";
import IconButton from "../../../atoms/icon-button";
import StatusLabel from "../../../atoms/status-label";
import OrderView from "../../order/order-view";
import GiftcardCreate from "../../giftcard/giftcard-create";
import ReleaseCompactItem from "../../inventory/release-compact-list-item";
import CartIndex from "../cart-index";
import RegisterCreate from "../../register/register-create";
import RegisterEdit from "../../register/register-edit";
import RegisterTransactionCreate from "../../register/register-transaction-create";
import Dropout from "../../dropout";
import ClientOrderCreate from "../../client-order/client-order-create";
import ClientOrderListItem from "../../client-order/client-order-list-item";
import ProductVariationCompactItem from "../../inventory/product-variation-compact-list-item";
import Discount from "../../discount";
import ManualDiscountCreate from "../../discount/manual-discount-create";
import OrderListItem from "../../order/order-list-item";
import Checkbox from "../../../atoms/checkbox";
import InputStack from "../../input-stack";
import {resolve} from "path";
import CartCheckoutScreen from "../cart-checkout-view";
import CartFulfillmentView from "../cart-fulfillment-view";
import RegisterClose from "../../register/register-close";
import {fetchActiveRegister} from "../../../../state/modules/register";
import CartShippingNotice from "../../cart-shipping-notice";
import CartRetourNotice from "../../cart-retour-notice";

class CartModule extends ModuleView {

    constructor(props) {

        super(props);
        
        this.customProductCreate = React.createRef();
        this.giftcardCreate = React.createRef();
        this.manualDiscount = React.createRef();
        this.cartViewScanner = React.createRef();
        
        let createInvoice = false;

        this.views = {
            index: <CartIndex
                onCartClick={(cart, register) => {
                    if (cart.order) {
                        this.openPopup('cartCheckoutView', {cart: cart, order: cart.order}, cart.id);
                        return;
                    }
                    
                    this.openPopup('cartView', {cart: cart, register: register}, cart.id);
                }}
                onOrderClick={order => this.openPopup('viewOrder', order, order.id)}
                onRegisterOpenClick={() => this.openPopup('createRegister', null, 'create-register')}
                onManageRegisterClick={register => this.openPopup('manageRegister', register, 'manage-register')}
                onCheckoutOrderClick={order => this.openPopup('checkoutOrder')}
            />
        };
        
        this.popups = {
            cartView: (props) => {
                let cart = (this.props.carts[props.cart.id] ? this.props.carts[props.cart.id] : props.cart);

                let customerCard = (
                    <div>No customer selected</div>
                );

                if (cart.customer) {
                    createInvoice = cart.customer.company_vat_valid;
                    
                    this.setState({
                        createInvoice: createInvoice,
                    });
                    
                    customerCard = (
                        <div>
                            <CustomerCard customer={cart.customer}/>
                            {cart.customer.company_vat_number &&
                                <InputStack>
                                    <Checkbox modifiers={'padding-top'} name="create_invoice" label="Create invoice" default={createInvoice} onChange={(checked) => {
                                        this.setState({
                                            createInvoice: checked,
                                        });
                                    }}/>
                                </InputStack>
                            }
                        </div>
                    );
                }
                
                let footer = (
                    <Button text={'Create order'} onClick={e => {
                        if (this.hasPreorderInCart(cart) && !this.hasCustomer(cart)) {
                            ui.notify('Please select a customer', 'error');
                            return;
                        }
                        
                        if (this.hasPreorderInCart(cart) && !this.hasShippingDetails(cart)) {
                            ui.notify('Please fill in customers\' shipping details', 'error');
                            return;
                        }
                        
                        this.closePopup('cartView', cart.id, () => {
                            // Add register id to request
                            http.post(API_HOST + API_ROOT + 'carts/' + cart.id + '/create-order', {
                                    register: cart.register.id,
                                    create_invoice: this.state.createInvoice,
                                }, true)
                                .then(response => {
                                    this.openPopup('cartCheckoutView', {
                                        cart: cart,
                                        order: response.order
                                    }, cart.id);
                                })
                        });
                    }}/>
                );

                let customerWindowHeader = (
                    <ButtonGroup>
                        <Button text="Create" modifiers="alt"
                                onClick={() => this.openPopup('customerCreate', cart, cart.id)}/>
                        <Button text={cart.customer ? 'Change' : 'Search'}
                                onClick={e => this.openPopup('customerSelect', cart, cart.id)}/>
                    </ButtonGroup>
                );

                let discountCode = (
                    <div>
                        {cart.discounts && cart.discounts.map(discount => {
                            return (
                                <Discount key={discount.discount_code.code} title={discount.label || discount.note || discount.discount_code.code} modifiers={'compact'}>
                                    <StatusLabel modifiers={'success'} title={'- ' + price(discount.value)}/>
                                    <IconButton iconType="delete" onClick={e => {
                                        this.props.removeDiscount(cart.id, discount.id).then(() => {
                                            ui.notify('Discount removed');

                                            this.props.updateList('carts');

                                            this.openPopup('cartView', {cart: cart}, cart.id);
                                        });
                                    }} />
                                </Discount>
                            );
                        })}
                        <ActionInput
                            buttonText={'Redeem'}
                            onSubmit={(code, field) => {
                                http.get(API_HOST + API_ROOT + 'discounts/findbycode', true, {code: code})
                                    .then(response => {
                                        this.props.addDiscount(cart.id, response.result.id)
                                            .then((response) => {
                                                if (response === undefined) {
                                                    ui.notify('Discount code already in cart', 'error');
                                                    return;
                                                }

                                                ui.notify('Discount added');

                                                this.props.updateList('carts');

                                                this.openPopup('cartView', {cart: cart}, cart.id);

                                                field.updateValue('');
                                            })
                                            .catch(error => handleTokenErrors(error));
                                    })
                                    .catch(error => {
                                        if (cart.discounts) {
                                            this.props.removeDiscount(cart.id).then(() => {
                                                this.props.updateList('carts');

                                                this.openPopup('cartView', {cart: cart}, cart.id);
                                            });
                                        }

                                        if (error.message === 'discount_code_not_found') {
                                            ui.notify('Discount code not found', 'error');
                                        }

                                        if (error.message === 'discount_code_usage_limit_exceeded') {
                                            ui.notify('Discount code usage limit exceeded', 'error');
                                        }
                                    })
                                    .catch(error => handleTokenErrors(error));
                            }}/>
                    </div>
                );
                
                // The POS discounts come from the CMS, so the staff percentage can be
                // changed there without a deploy. "Bedrag" is the free amount.
                // ButtonGroup wraps each child in its own item, so the buttons go in as
                // one flat list; a nested array would share a single item and lose the
                // spacing the other menus have.
                let posDiscountButtons = this.state.posDiscounts.map(promoCode => (
                    <Button
                        key={promoCode.id}
                        modifiers={['small']}
                        text={promoCode.code + ' (' + promoCode.formatted_discount + ')'}
                        onClick={() => this.openPopup('manualDiscount', {
                            cart: cart,
                            promoCode: promoCode,
                        }, cart.id)}
                    />
                ));

                posDiscountButtons.push(
                    <Button
                        key={'amount'}
                        modifiers={['small', 'alt']}
                        text="amount"
                        onClick={() => this.openPopup('manualDiscount', {
                            cart: cart,
                            promoCode: null,
                        }, cart.id)}
                    />
                );

                let posDiscounts = (
                    <Dropout modifiers={'align-right'} icon={'list'}>
                        <ButtonGroup>
                            {posDiscountButtons}
                        </ButtonGroup>
                    </Dropout>
                );

                let plasticBag = null;

                if (this.state.plasticBagCustomProductType) {
                    plasticBag = (
                        <Button modifiers={['small']} text="plastic bag"
                                onClick={() => {
                                    this.props.addCustomProduct(cart.id, this.state.plasticBagCustomProductType.id, {amount: 1}).then(() => {
                                        ui.notify('Plastic bag added to cart');
            
                                        this.openPopup('cartView', {cart: cart}, cart.id);
            
                                        this.props.updateList('carts');
                                        this.props.updateList('cart-items-' + cart.id);
                                    });
                                }}/>
                    );
                }
                
                let ticket = null;
                
                if (this.state.ticketProductType) {
                    ticket = (
                        <Button modifiers={['small']} text="ticket"
                                onClick={() => {
                                    this.openPopup('customProductAdd', {
                                        customProductType: this.state.ticketProductType,
                                        cart: cart
                                    }, cart.id);
                                }}/>
                    );
                }
                
                let shipping = null;
                
                if (cart.fulfillment_method !== null) {
                    shipping = (
                        <CartShippingNotice cart={cart} />
                    );
                }
                
                let retour = null;
                
                if (cart.has_retour === true) {
                    retour = (
                        <CartRetourNotice cart={cart} />
                    );
                }

                return (
                    <Popup
                        title={'Cart #' + cart.id}
                        onClose={() => {
                            this.closePopup('cartView', cart.id, () => {
                                this.props.updateList('carts');
                            });
                        }}
                        fullscreen={true}
                        footer={footer}
                    >
                        <Grid cols={'5fr 3fr'}>
                            <Window title={cart.items ? "Products (" + cart.items.length + ")" : "Products"} modifiers={['frame', 'non-padded']} header={
                                <ButtonGroup>
                                    <Button modifiers={'small'} text="release"
                                            onClick={() => this.openPopup('releaseSelect', cart, cart.id)}/>
                                    <Button modifiers={'small'} text="2nd hand"
                                            onClick={() => {
                                                if (this.state.secondHandCustomProductType) {
                                                    this.openPopup('customProductAdd', {
                                                        customProductType: this.state.secondHandCustomProductType,
                                                        cart: cart
                                                    }, cart.id);
                                                }
                                            }}/>

                                    <Button modifiers={['small', 'alt']} text="custom product"
                                            onClick={() => this.openPopup('customProductTypeSelect', cart, cart.id)} />
                                    <Button modifiers={['small', 'alt']} text="giftcard"
                                            onClick={() => this.openPopup('giftcardCreate', cart, cart.id)}/>
                                    <Dropout title={'Other'} modifiers={'align-right'} buttonModifiers={['alt']}
                                             icon={'list'}>
                                        <ButtonGroup>
                                            { plasticBag }
                                            { ticket }
                                            <Button modifiers={['small']} text="product"
                                                    onClick={() => this.openPopup('productVariationSelect', cart, cart.id)}/>
                                            <Button text="create KB" onClick={() => {
                                                if (!cart.customer) {
                                                    ui.notify('No customer selected', 'error');
                                                    return;
                                                }
                                                
                                                this.openPopup('createClientOrder', cart, 'create-client-order');
                                            }}/>
                                            <Button modifiers={'alt'} text="pick KB"
                                                    onClick={() => this.openPopup('clientOrderSelect', cart, 'select-client-order')}/>
                                        </ButtonGroup>
                                    </Dropout>
                                </ButtonGroup>
                            }>
                                <BarcodeScanner
                                    ref={this.cartViewScanner}
                                    isScanning={!this.state.activeEditingCartItem}
                                    {...this.buildScannerHandlers(cart)}
                                />
                                <List
                                    id={'cart-items-' + cart.id}
                                    model={'cart-items'}
                                    selectable={false}
                                    sort={{
                                        sort_created: 'desc',
                                        sort_updated: 'desc',
                                    }}
                                    filters={{
                                        filter_cart: [
                                            {key: cart.id}
                                        ]
                                    }}
                                >
                                    <CartItem
                                        active={this.id === this.state.activeEditingCartItem}
                                        onQuantityChange={(cartItem, newQuantity) => {
                                            this.props.changeCartItemQuantity(cart.id, cartItem.id, newQuantity).then(() => {
                                                this.props.updateList('carts');
                                                this.props.updateList('cart-items-' + cart.id);
                                                this.openPopup('cartView', {cart: cart}, cart.id);
                                            });
                                        }}
                                        onEdit={cartItemId => {
                                            this.setState({
                                                activeEditingCartItem: cartItemId,
                                            })
                                        }}
                                        onCancel={() => {
                                            this.setState({
                                                activeEditingCartItem: null,
                                            })
                                        }}
                                        onDelete={cartItem => {
                                            this.props.removeCartItem(cart.id, cartItem.id).then(() => {
                                                return this.props.getCart(cart.id);
                                            }).then(() => {
                                                this.props.updateList('carts');
                                                this.props.updateList('cart-items-' + cart.id);
                                                this.openPopup('cartView', {cart: this.props.carts[cart.id]}, cart.id);
                                                ui.notify('Item removed from cart');
                                            });
                                        }}
                                        onSave={(cartId, cartItem, data) => {
                                            this.setState({
                                                activeEditingCartItem: null,
                                            })

                                            this.props.updateCartItem(cartId, cartItem.id, data).then(() => {
                                                this.updateView();
                                                this.props.updateList('carts');
                                                this.props.updateList('cart-items-' + cart.id);
                                                this.openPopup('cartView', {cart: cart}, cart.id);
                                                this.updateView('index');
                                                ui.notify('Price updated');
                                            });
                                        }}
                                    />
                                </List>
                                {retour}
                                {shipping}
                            </Window>
                            <Grid rows={'2fr auto 8fr'}>
                                <NumberWidget prefix="€" value={cart.total.toFixed(2)} title="Order total"/>
                                <Window title={'Discount'} modifiers={['frame', 'padded']} header={
                                    <ButtonGroup>
                                        {cart.discount_code &&
                                            <IconButton modifiers="alt" iconType="delete" onClick={e => {
                                                this.props.removeDiscount(cart.id).then(() => {
                                                    ui.notify('Discount removed');
                                                    this.props.updateList('carts');
                                                    this.openPopup('cartView', {cart: cart}, cart.id);
                                                });
                                            }}/>
                                        }
                                        {posDiscounts}
                                    </ButtonGroup>
                                }>
                                    {discountCode}
                                </Window>
                                <Window title={'Customer'} modifiers={['frame', 'padded']}
                                        header={customerWindowHeader}>
                                    {customerCard}
                                </Window>
                            </Grid>
                        </Grid>
                    </Popup>
                );
            },
            cartCheckoutView: (props) => {
                let content = null;
                let footer = null;

                let cart = (this.props.carts[props.cart.id] ? this.props.carts[props.cart.id] : props.cart);

                return (
                    <CartCheckoutScreen
                        cart={cart}
                        order={props.order}
                        createInvoice={this.state.createInvoice}
                        onSuccess={(ticket, giftcardPrintUrl) => {
                            this.setState({
                                createInvoice: false,
                            });

                            if (ticket) {
                                let printWindow = window.open('', '_blank');
                                if (printWindow) {
                                    printWindow.document.open();
                                    printWindow.document.write(ticket);
                                    printWindow.document.close();
                                }
                            }

                            this.props.deleteCart(cart.id).then(() => {
                                this.props.updateList('cash-desk-orders');
                                this.props.updateList('carts');

                                this.closePopup('cartCheckoutView', cart.id, () => {
                                    if (giftcardPrintUrl) {
                                        this.openPopup('printGiftcardView', {giftcardPrintUrl: giftcardPrintUrl}, 'print-giftcard');
                                    }
                                });

                                ui.notify('Payment succeeded');
                            });

                            resolve();
                        }}
                        onFail={(message) => {
                            ui.notify(message, 'error');
                            
                            resolve();
                        }}
                        onCancel={() => {
                            http.delete(API_HOST + API_ROOT + 'carts/' + cart.id + '/cancel-order', {}, true)
                                .then(response => {
                                    this.closePopup('cartCheckoutView', cart.id, () => {
                                        this.openPopup('cartView', {cart: cart}, cart.id);
                                    });
                                })
                           
                        }}
                        onHide={() => {
                            this.closePopup('cartCheckoutView', cart.id, () => {
                                // TODO: try to only perform one call
                                this.props.updateList('carts');

                                this.props.getCart(cart.id);
                            });

                            resolve();
                        }}
                    />
                );
            },
            manualDiscount: (props) => {
                let cart = (this.props.carts[props.cart.id] ? this.props.carts[props.cart.id] : props.cart);
                let promoCode = props.promoCode;

                return (
                    <Popup
                        title={promoCode ? promoCode.code : 'Discount amount'}
                        toggle={true}
                        footer={<Button text="Apply" onClick={e => this.manualDiscount.current.form.current.submit()}/>}
                    >
                        <ManualDiscountCreate
                            ref={this.manualDiscount}
                            promoCode={promoCode}
                            onSave={(data) => {
                                this.props.addManualDiscount(cart.id, data)
                                    .then(() => {
                                        ui.notify('Discount added');

                                        this.props.updateList('carts');

                                        this.closePopup('manualDiscount', cart.id, () => {
                                            this.openPopup('cartView', {cart: cart}, cart.id);
                                        });
                                    })
                                    .catch(error => {
                                        if (error.message === 'discount_code_already_used') {
                                            ui.notify('Discount already in cart', 'error');
                                            return;
                                        }

                                        if (error.message === 'invalid_discount_amount') {
                                            ui.notify('Fill in an amount above zero', 'error');
                                            return;
                                        }

                                        if (error.message === 'note_required') {
                                            ui.notify('A note is required on an amount discount', 'error');
                                            return;
                                        }

                                        handleTokenErrors(error);
                                    });
                            }}
                        />
                    </Popup>
                );
            },
            printGiftcardView: (props) => {
                return (
                    <Popup
                        title={'Print giftcards'}
                        onClose={() => this.closePopup('printGiftcardView', 'print-giftcard')}
                    >
                        <Button
                            text={'Print giftcards'}
                            onClick={() => {
                                // One link for every giftcard on the order, so they
                                // come out of the DYMO as a single print job.
                                window.open(props.giftcardPrintUrl, '_blank');
                                this.closePopup('printGiftcardView', 'print-giftcard');
                            }}
                        />
                    </Popup>
                );
            },
            customerSelect: (cart) => {
                
                cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart);
                
                return (
                    <ItemSelectPopup
                        itemName="Customer"
                        listId={'customers-select'}
                        model={'customers'}
                        onItemSelectConfirm={customer => {
                            
                            this.props.updateCart(cart.id, {
                                customer: customer.id
                            }).then(() => {
                                
                                ui.notify('Customer selected');
                                
                                this.props.updateList('carts');
                                this.openPopup('cartView', {cart: cart}, cart.id);
                                this.closePopup('customerSelect', cart.id);
                            });
                        }}
                        onItemDeselect={() => {

                            this.props.updateCart(cart.id, {
                                customer: null
                            }).then(() => {

                                this.props.updateList('carts');
                                this.openPopup('cartView', {cart: cart}, cart.id, () => {
                                    this.closePopup('customerSelect', cart.id);
                                });
                            });
                        }}
                    >
                        <CustomerSelectListItem/>
                    </ItemSelectPopup>
                );
            },
            releaseSelect: (cart) => {
                let barcode = null;

                if (cart.barcode) {
                    barcode = cart.barcode;
                    cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart.cart);
                }
                else {
                    cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart);
                }

                return (
                    <ItemSelectPopup
                        itemName="Release"
                        listId={'releases-select'}
                        model={'releases'}
                        search={barcode}
                        onItemSelectConfirm={release => {
                            this.closePopup('releaseSelect', cart.id, () => {
                                if (release.is_preorderable && !this.hasPreorderInCart(cart)) {
                                    this.openPopup('fulfillmentMethodSelect', {
                                        cart: cart,
                                        release: release
                                    }, 'fulfillment-method-select');
                                    
                                    return;
                                }
                                
                                this.handleAddRelease(cart, release);
                            });
                        }}
                        onItemDeselect={() => this.closePopup('releaseSelect', cart.id)}
                    >
                        <ReleaseCompactItem/>
                    </ItemSelectPopup>
                );
            },
            customerCreate: (cart) => {
                cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart);

                return (
                    <Popup title="Customer">
                        <CustomerCreate onSave={customer => {

                            this.props.updateCart(cart.id, {
                                customer: customer.id
                            }).then(() => {

                                ui.notify('Customer created');
                                this.props.updateList('carts');
                                this.closePopup('customerCreate', cart.id, () => {
                                    this.openPopup('cartView', {cart: cart}, cart.id);
                                });
                            });

                        }}/>
                    </Popup>
                );
            },
            productVariationSelect: (cart) => {
                cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart);

                return (
                    <ItemSelectPopup
                        itemName="Product"
                        listId={'product-variations-select'}
                        model={'product_variations'}
                        onItemSelectConfirm={product => {
                            this.props
                                .addProductVariation(cart.id, product.id, {
                                    amount: 1
                                })
                                .then(() => {
                                    ui.notify('Product added to cart');

                                    this.openPopup('cartView', {
                                        cart: cart
                                    }, cart.id);

                                    this.props.updateList('carts');
                                    this.props.updateList('cart-items-' + cart.id);
                                })

                            this.closePopup('productVariationSelect', cart.id);
                        }}
                        onItemDeselect={() => this.closePopup('productVariationSelect', cart.id)}
                    >
                        <ProductVariationCompactItem/>
                    </ItemSelectPopup>
                );
            },
            customProductTypeSelect: (cart) => {

                cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart);

                return (
                    <ItemSelectPopup
                        itemName="Product type"
                        listId={'custom-product-types-select'}
                        model={'custom-product-types'}
                        fullscreen={false}
                        required={true}
                        onItemSelectConfirm={customProductType => {
                            this.closePopup('customProductTypeSelect', cart.id, () => {
                                if (customProductType.price > 0) {
                                    http.post(API_HOST+API_ROOT + 'custom-products', {
                                        price: customProductType.price,
                                        custom_product_type: customProductType.id,
                                    }, true)
                                    .then(response => {
                                        if (response.success) {
                                            this.props.addCustomProduct(cart.id, response.result.id, {amount: 1})
                                            .then(() => {
                                                ui.notify('Custom product added to cart');
                                                
                                                this.openPopup('cartView', {cart: cart}, cart.id);
                                                this.props.updateList('carts');
                                                this.props.updateList('cart-items-' + cart.id);
                                            });
                                        }
                                    })
                                    .catch(error => {
                                        if (error.message === 'duplicate_custom_product') {
                                            ui.notify('A custom product with that id already exists', 'error');
                                        }
                                    });
                                    
                                    return;
                                }
                                
                                this.openPopup('customProductAdd', {
                                    customProductType: customProductType,
                                    cart: cart
                                }, cart.id);
                            });
                        }}
                    >
                        <CustomProductTypeListItem/>
                    </ItemSelectPopup>
                );
            },
            customProductAdd: (props) => {

                let cart = (this.props.carts[props.cart.id] ? this.props.carts[props.cart.id] : props.cart);

                return (
                    <Popup title={'Add ' + props.customProductType.title} footer={
                        <Button text="Create" onClick={e => this.customProductCreate.current.form.current.submit()}/>
                    }>
                        <CustomProductCreate
                            ref={this.customProductCreate}
                            customProductType={props.customProductType}
                            onSave={customProduct => {

                                this.props.addCustomProduct(cart.id, customProduct.id, {amount: 1}).then(() => {

                                    ui.notify('Custom product added to cart');

                                    this.openPopup('cartView', {cart: cart}, cart.id);
                                    this.props.updateList('carts');
                                    this.props.updateList('cart-items-' + cart.id);
                                });

                                this.closePopup('customProductAdd', cart.id);
                            }}
                            onCancel={() => {
                                this.closePopup('customProductAdd', cart.id, () => {
                                    this.openPopup('customProductTypeSelect', cart, cart.id);
                                });
                            }}
                        />
                    </Popup>
                );
            },
            giftcardCreate: (cart) => {

                cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart);

                return (
                    <Popup title={'Add giftcard'} footer={<Button text="Create"
                                                                  onClick={e => this.giftcardCreate.current.form.current.submit()}/>}>
                        <GiftcardCreate
                            ref={this.giftcardCreate}
                            onSave={giftcard => {

                                this.props.addGiftcard(cart.id, giftcard.id, {amount: 1}).then(() => {

                                    ui.notify('Giftcard added to cart');

                                    this.openPopup('cartView', {cart: cart}, cart.id);
                                    this.props.updateList('carts');
                                    this.props.updateList('cart-items-' + cart.id);
                                });

                                this.closePopup('giftcardCreate', cart.id);
                            }}
                            onCancel={() => {
                                this.closePopup('giftcardCreate', cart.id, () => {
                                    this.openPopup('cartView', {cart: cart}, cart.id);
                                });
                            }}
                        />
                    </Popup>
                );

            },
            clientOrderCreate: (cart) => {

                cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart);

                return (
                    <Popup title={'Create Client Order'}>
                        <ClientOrderCreate
                            customer={cart.customer}
                            location={this.props.activeRegister && this.props.activeRegister.location ? this.props.activeRegister.location.id : null}
                            onSave={(clientOrder) => {

                            this.props.addClientOrder(cart.id, clientOrder.id, {amount: 1}).then(() => {

                                ui.notify(clientOrder.title + ' created');

                                this.openPopup('cartView', {cart: cart}, cart.id);
                                this.props.updateList('carts');
                                this.props.updateList('cart-items-' + cart.id);
                            });

                            this.closePopup('clientOrderCreate', 'create-client-order');
                        }}/>
                    </Popup>
                );
            },
            clientOrderSelect: (cart) => {

                cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart);

                return (
                    <ItemSelectPopup
                        itemName="Client Orders ready for pickup"
                        listId={'client-orders-select'}
                        model={'client-orders'}
                        filters={{
                            filter_status: [{key: 'ready_for_pickup'}],
                        }}
                        required={true}
                        onItemSelectConfirm={clientOrder => {

                            this.props.addClientOrder(cart.id, clientOrder.id, {amount: 1}).then(() => {

                                ui.notify('Client order added to cart');

                                this.openPopup('cartView', {cart: cart}, cart.id);
                                this.props.updateList('carts');
                                this.props.updateList('cart-items-' + cart.id);
                            });

                            this.closePopup('clientOrderSelect', 'select-client-order');
                        }}
                    >
                        <ClientOrderListItem />
                    </ItemSelectPopup>
                );
            },
            viewOrder: (order) => {
                return (
                    <Popup title={'Order ' + order.id} toggle={true}>
                        <OrderView order={order}/>
                    </Popup>
                );
            },
            createRegister: () => {
                return (
                    <Popup title={'Register'} toggle={true}>
                        <RegisterCreate onSave={register => {
                            this.updateView();
                            
                            this.closePopup('createRegister', 'create-register', () => {
                                this.props.fetchActiveRegister();
                                
                                this.updateView('index');
                                
                                ui.notify(register.hid + ' created');
                            })
                        }}/>
                    </Popup>
                );
            },
            manageRegister: (register) => {
                return (
                    <Popup title={'Manage ' + register.hid} toggle={true} fullscreen={true}>
                        <RegisterEdit
                            register={register}
                            onRegisterTransactionCreate={(register, type) => {
                                this.openPopup('createRegisterTransaction', {
                                    register: register,
                                    type: type
                                }, 'create-register-transaction');
                            }}
                            onOpenClosePopup={(register) => {
                                this.openPopup('closeRegister', register, 'close-register');
                            }}
                        />
                    </Popup>
                );
            },
            createRegisterTransaction: (props) => {
                return (
                    <Popup title={props.type === 'in' ? 'Add cash to register' : 'Remove cash from register'}
                           toggle={true}>
                        <RegisterTransactionCreate
                            register={props.register}
                            type={props.type}
                            onSave={register => {
                                this.closePopup('createRegisterTransaction', 'create-register-transaction', () => {
                                    this.closePopup('manageRegister', 'manage-register', () => {
                                        this.openPopup('manageRegister', register, 'manage-register');
                                    });
                                    ui.notify('Register transaction created');
                                });
                            }}
                        />
                    </Popup>
                );
            },
            closeRegister: (register) => {
                return (
                    <Popup title={'Close ' + register.hid} toggle={true}>
                        <RegisterClose register={register} onSave={(register) => {
                            this.props.lists.carts.items.forEach(cart => {
                                this.props.deleteCart(cart.id);
                            });
                            
                            this.updateView();
                            
                            this.closePopup('closeRegister', 'close-register', () => {
                                this.props.fetchActiveRegister();
                                
                                this.closePopup('manageRegister', 'manage-register', () => {
                                    this.updateView('index');
                                    
                                    ui.notify(register.hid + ' closed');
                                });
                            });
                        }}></RegisterClose>
                    </Popup>
                );
            },
            checkoutOrder: () => {
                return (
                    <Popup title={'Checkout order'} toggle={true}>
                        <BarcodeScanner
                            isScanning={true}
                            list={'orders'}
                            onOrderFound={order => {
                                this.openPopup('checkoutOrderView', order[0]);
                            }}
                            onMultipleOrdersFound={(orders, barcode) => {
                                this.openPopup('checkoutOrderSelect', {
                                    orders: orders,
                                    barcode: barcode,
                                });
                            }}
                        />
                    </Popup>
                );
            },
            checkoutOrderSelect: (checkout) => {
                let barcode = null;
    
                if (checkout.barcode) {
                    barcode = checkout.barcode;
                }
                
                return (
                    <ItemSelectPopup
                        itemName="Order"
                        listId={'orders'}
                        model={'orders'}
                        search={barcode}
                        filters={{
                            filter_status: [{
                                key: 1, value: "Paid",
                            }],
                            filter_fulfillment_method: [{
                                key: 1
                            }],
                            filter_post_payment_status: [{
                                key: 4
                            }]
                        }}
                        onItemSelectConfirm={order => {
                            this.closePopup('checkoutOrder');
                            this.closePopup('checkoutOrderSelect');
                            this.openPopup('checkoutOrderView', order);
                        }}
                        onItemDeselect={() => {
                            this.closePopup('checkoutOrder');
                            this.closePopup('checkoutOrderSelect');
                        }}
                    >
                        <OrderListItem />
                    </ItemSelectPopup>
                );
            },
            checkoutOrderView: (order) => {
                let checkoutButton = order.fulfillment_method === 1 && order.post_payment_status !== 3 && (
                    <Button
                        key={'checkout'}
                        text={'Checkout'}
                        onClick={() => {
                            this.checkoutOrder(order, order.id);
                        }}
                        modifiers={'small'}
                    />
                );
                
                return (
                    <Popup
                        key={order.id}
                        title={'Order ' + order.id}
                        toggle={true}
                        footer={checkoutButton}
                    >
                        <OrderView order={order}/>
                    </Popup>
                );
            },
            createClientOrder: (cart) => {
                cart = (this.props.carts[cart.id] ? this.props.carts[cart.id] : cart);
                
                return (
                    <Popup title={'Create Client Order'} toggle={true}>
                        <ClientOrderCreate
                            customer={cart.customer}
                            location={this.props.activeRegister && this.props.activeRegister.location ? this.props.activeRegister.location.id : null}
                            onSave={(clientOrder) => {
                            this.props.addClientOrder(cart.id, clientOrder.id, {amount: 1}).then(() => {
                                ui.notify('Client Order created');

                                this.openPopup('cartView', {cart: cart}, cart.id);
                                this.props.updateList('carts');
                                this.props.updateList('cart-items-' + cart.id);
                            });

                            this.closePopup('createClientOrder', 'create-client-order');
                        }}/>
                    </Popup>
                )
            },
            fulfillmentMethodSelect: (props) => {
                let cart = (this.props.carts[props.cart.id] ? this.props.carts[props.cart.id] : props.cart);
                let release = props.release;
                
                return (
                    <CartFulfillmentView
                        cart={cart}
                        release={release}
                        onShipping={() => {
                            this.closePopup('fulfillmentMethodSelect', 'fulfillment-method-select', () => {
                                this.handleAddRelease(cart, release);
                            });
                        }}
                        onPickup={(locationId) => {
                            this.closePopup('fulfillmentMethodSelect', 'fulfillment-method-select', () => {
                                this.handleAddRelease(cart, release);
                            });
                        }}
                        onCancel={() => {
                            this.closePopup('fulfillmentMethodSelect', 'fulfillment-method-select');
                        }}
                    />
                );
            }
        };

        this.state = {
            cart: {
                total: null,
                remaining: null,
            },
            view: this.views.index,
            customProductTypes: [],
            createInvoice: false,
            cardPaymentLoading: false,
            payment: {
                total: null,
                remaining: null,
                mollie: null,
                cash: null,
            },
            posDiscounts: [],
            secondHandCustomProductType: null,
            plasticBagCustomProductType: null,
            bxlStockCustomProductType: null,
            ticketProductType: null,
            activeEditingCartItem: null,
        };
    }

    // A scan reaches here without any input having been selected first.
    handleScan(barcode) {
        let activePopup = this.state.activePopup;

        // The cart is already open: hand the code to its own scanner so it lights up
        // and behaves exactly as if it had been typed into it.
        if (activePopup && activePopup.name === 'cartView' && this.cartViewScanner.current) {
            this.cartViewScanner.current.scan(barcode);
            return;
        }

        // Anything else on top of the index owns the screen, leave it alone.
        // CartModule replaces ModuleView's state, so popups can still be undefined.
        if ((this.state.popups || []).length || ! this.props.activeRegister) {
            return;
        }

        this.props.addCart(this.props.activeRegister).then(response => {
            if (! response) {
                return;
            }

            let cart = response.result;

            this.props.updateList('carts');
            this.openPopup('cartView', {cart: cart, register: this.props.activeRegister}, cart.id);

            resolveBarcode(barcode, {handlers: this.buildScannerHandlers(cart)});
        });
    }

    render() {
        return (
            <React.Fragment>
                <BarcodeListener onBarcode={barcode => this.handleScan(barcode)}/>
                {super.render()}
            </React.Fragment>
        );
    }

    componentDidMount() {
        http
            .request({url: API_HOST + API_ROOT + 'custom-product-types'}, true)
            .then(response => {
                const { items = [] } = response?.result;
                
                const secondHandCustomProductType = items.find(item => item.title === 'Tweedehands release');
                const ticketProductType = items.find(item => item.title === 'Democrazy ticket');
                const bxlStockCustomProductType = items.find(item => item.title === 'BXL Stock');
                
                this.setState({ secondHandCustomProductType, ticketProductType, bxlStockCustomProductType });
            });
        
        http
            .request({url: API_HOST + API_ROOT + 'discounts/pos'}, true)
            .then(response => {
                const { items = [] } = response?.result;

                this.setState({ posDiscounts: items });
            })
            .catch(error => handleTokenErrors(error));

        http
            .request({url: API_HOST + API_ROOT + 'custom-products/plastic-bag'}, true)
            .then(response => {
                const plasticBagCustomProductType = response?.result;

                this.setState({ plasticBagCustomProductType });
            })
            .catch(error => {
                if (error === 'plastic_bag_not_found') {
                    ui.notify('Plastic bag not found', 'error');
                }
            });
    }
    
    hasPreorderInCart(cart) {
        if (!cart.items || cart.items.length === 0) {
            return false;
        }
        
        return cart.items.some(item => item.buyable && item.buyable.is_preorderable);
    }
    
    hasCustomer(cart) {
        return cart.customer;
    }
    
    hasShippingDetails(cart) {
        const customer = cart?.customer;
        
        return customer.address_street && customer.address_street_number && customer.address_postal_code && customer.address_city && customer.address_country;
    }
    
    // Shared by the scanner inside cartView and the one on the index, so a scan
    // behaves the same whether the cart already existed or was just created.
    buildScannerHandlers(cart) {
        return {
            onReleaseFound: (release) => {
                if (release.is_preorderable && !this.hasPreorderInCart(cart)) {
                    this.openPopup('fulfillmentMethodSelect', {
                        cart: cart,
                        release: release
                    }, 'fulfillment-method-select');

                    return;
                }

                this.handleAddRelease(cart, release);
            },
            onMultipleReleasesFound: (releases, barcode) => {
                this.openPopup('releaseSelect', {
                    cart: cart,
                    barcode: barcode,
                }, cart.id);
            },
            onProductFound: (product) => {
                this.props.addProductVariation(cart.id, product.id, {amount: 1}).then(() => {
                    this.openPopup('cartView', {cart: cart}, cart.id);
                    this.props.updateList('carts');
                    this.props.updateList('cart-items-' + cart.id);
                    ui.notify('Product added to cart');
                });
            },
            onSecondHand: () => {
                if (this.state.secondHandCustomProductType) {
                    this.openPopup('customProductAdd', {
                        customProductType: this.state.secondHandCustomProductType,
                        cart: cart
                    }, cart.id);
                }
            },
            onBxlStock: () => {
                if (this.state.bxlStockCustomProductType) {
                    this.openPopup('customProductAdd', {
                        customProductType: this.state.bxlStockCustomProductType,
                        cart: cart
                    }, cart.id);
                }
            },
            onPlasticBag: () => {
                this.props.addCustomProduct(cart.id, this.state.plasticBagCustomProductType.id, {amount: 1}).then(() => {
                    ui.notify('Plastic bag added to cart');

                    this.openPopup('cartView', {cart: cart}, cart.id);
                    this.props.updateList('carts');
                    this.props.updateList('cart-items-' + cart.id);
                });
            },
            onGiftcardFound: (code) => {
                this.props.addDiscount(cart.id, code.id)
                    .then((response) => {
                        if (response === undefined) {
                            ui.notify('Discount code already in cart', 'error');
                            return;
                        }

                        ui.notify('Discount added');

                        this.openPopup('cartView', {cart: cart}, cart.id);
                        this.props.updateList('carts');
                        this.props.updateList('cart-items-' + cart.id);
                    })
                    .catch(error => handleTokenErrors(error));
            },
            onCustomProductTypeFound: (customProductType) => {
                if (customProductType.price > 0) {
                    http.post(API_HOST+API_ROOT + 'custom-products', {
                        price: customProductType.price,
                        custom_product_type: customProductType.id,
                    }, true)
                    .then(response => {
                        if (response.success) {
                            this.props.addCustomProduct(cart.id, response.result.id, {amount: 1})
                            .then(() => {
                                ui.notify('Custom product added to cart');

                                this.openPopup('cartView', {cart: cart}, cart.id);
                                this.props.updateList('carts');
                                this.props.updateList('cart-items-' + cart.id);
                            });
                        }
                    })
                    .catch(error => {
                        if (error.message === 'duplicate_custom_product') {
                            ui.notify('A custom product with that id already exists', 'error');
                        }
                    });

                    return;
                }

                this.openPopup('customProductAdd', {
                    customProductType: customProductType,
                    cart: cart
                }, cart.id);
            },
        };
    }

    handleAddRelease(cart, release, additionalData = {}) {
        const data = {amount: 1, ...additionalData};
        
        this.props.addRelease(cart.id, release.id, data).then(() => {
            this.openPopup('cartView', {cart: cart}, cart.id);
            this.props.updateList('carts');
            this.props.updateList('cart-items-' + cart.id);
            ui.notify('Release added to cart');
        });
    }
    
    checkoutOrder(order, orderId) {
        http
            .post(API_HOST + API_ROOT + 'orders/' + orderId + '/checkout', {}, true)
            .then(response => {
                this.closePopup('checkoutOrder');
                this.closePopup('checkoutOrderSelect');
                this.closePopup('checkoutOrderView');
                
                ui.notify('Client order checked out');
            })
            .catch(error => {
                ui.notify('There was an error, client order couldn\'t be checked out', 'error');
            })
    }
}

const mapStateToProps = (state) => ({
    carts: state.carts.carts,
    lists: state.resources.lists,
    activeRegister: state.register.activeRegister,
});

const mapDispatchToProps = {
    setList: setList,
    updateList: updateList,
    addCart: addCart,
    getCarts: fetchCarts,
    getCart: fetchCart,
    addDiscount: addDiscount,
    addManualDiscount: addManualDiscount,
    removeDiscount: removeDiscount,
    updateCart: updateCart,
    deleteCart: deleteCart,
    addRelease: addRelease,
    addProductVariation: addProductVariation,
    addCustomProduct: addCustomProduct,
    addGiftcard: addGiftcard,
    addClientOrder: addClientOrder,
    updateRelease: updateRelease,
    updateProductVariation: updateProductVariation,
    removeCartItem: removeCartItem,
    updateCartItem: updateCartItem,
    changeCartItemQuantity: changeCartItemQuantity,
    checkoutCart: checkoutCart,
    checkoutMollieCart: checkoutMollieCart,
    fetchActiveRegister: fetchActiveRegister,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartModule);
